import React, { useState } from 'react';
import { Dialog, DialogTitle, DialogContent, IconButton, Box, TextField, Button, CircularProgress, FormControlLabel, Checkbox, Typography } from '@mui/material';
import CloseIcon from '@mui/icons-material/Close';
import VariantSelect from './VariantSelect';
import { createPurchase } from '../api/purchases';

interface AddPurchaseModalProps {
  open: boolean;
  onClose: () => void;
  contactId: string;
  onPurchaseCreated: () => void;
}

function AddPurchaseModal({ open, onClose, contactId, onPurchaseCreated }: AddPurchaseModalProps): React.JSX.Element {
  const [variantId, setVariantId] = useState('');
  const [amount, setAmount] = useState('');
  const [receiptUrl, setReceiptUrl] = useState('');
  const [notes, setNotes] = useState('');
  const [autoReceipt, setAutoReceipt] = useState(false);
  const [loading, setLoading] = useState(false);

  const handleSubmit = async (e: React.FormEvent) => {
    e.preventDefault();
    if (!variantId || !amount) return;
    setLoading(true);
    try {
      await createPurchase({
        contact_id: contactId,
        variant_id: variantId,
        amount: Number(amount),
        receipt_url: receiptUrl || undefined,
        notes: notes || undefined,
        auto_receipt: autoReceipt,
      });
      setVariantId('');
      setAmount('');
      setReceiptUrl('');
      setNotes('');
      setAutoReceipt(false);
      onPurchaseCreated();
      onClose();
    } finally {
      setLoading(false);
    }
  };

  return (
    <Dialog open={open} onClose={onClose} maxWidth="sm" fullWidth>
      <DialogTitle>
        הוספת רכישה
        <IconButton
          aria-label="close"
          onClick={onClose}
          sx={{ position: 'absolute', right: 8, top: 8, color: (theme) => theme.palette.grey[500] }}
        >
          <CloseIcon />
        </IconButton>
      </DialogTitle>
      <DialogContent>
        <Box component="form" onSubmit={handleSubmit} sx={{ mt: 2, display: 'flex', flexDirection: 'column', gap: 2 }}>
          <VariantSelect 
            value={variantId} 
            onChange={setVariantId} 
            label="קורס" 
          />
          <TextField label="סכום" type="number" value={amount} onChange={e => setAmount(e.target.value)} required fullWidth />
          <FormControlLabel
            control={
              <Checkbox
                checked={autoReceipt}
                onChange={(e) => setAutoReceipt(e.target.checked)}
              />
            }
            label="הפק קבלה אוטומטית"
          />
          <Typography>כדי להפיק חשבונית אוטומטית חייב שם הורה</Typography>
          <TextField 
            label="קישור קבלה" 
            value={receiptUrl} 
            onChange={e => setReceiptUrl(e.target.value)} 
            disabled={autoReceipt}
            fullWidth 
          />
          <TextField label="הערות" value={notes} onChange={e => setNotes(e.target.value)} multiline rows={3} fullWidth />
          <Button type="submit" variant="contained" disabled={loading || !variantId || !amount}>
            {loading ? <CircularProgress size={20} /> : 'הוסף רכישה'}
          </Button>
        </Box>
      </DialogContent>
    </Dialog>
  );
}

export default AddPurchaseModal;
 